import { render } from "./CoursesBackButton.vue?vue&type=template&id=0a91d5b7"
import script from "./CoursesBackButton.vue?vue&type=script&lang=js"
export * from "./CoursesBackButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__